import MUIDataTable from "mui-datatables";
import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import moment from "moment";
import { fontSize } from "@mui/system";
const ItemReportsTable = ({ report }) => {
  const columns = [
    {
      name: "image",
      label: "",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <img
              src={value}
              alt="item"
              style={{
                width: "70px",
                height: "70px",
                borderRadius: "10px",
                objectFit: "contain",
                boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
              }}
            />
          );
        },
      },
    },

    {
      name: "name",
      label: "Item",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "price",
      label: "Price",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "count",
      label: "Quantity",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "totalToPay",
      label: "Total",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "paidCount",
      label: "Paid Quantity",
      options: {
        filter: false,
        sort: true,
      },
    },

    {
      name: "totalPaid",
      label: "Paid",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "difference",
      label: "Balance",
      options: {
        filter: false,
        sort: true,
      },
    },
  ];

  const options = {
    print: false,
    selectableRowsHideCheckboxes: true,
    responsive: "simple",
    download: true,
  };

  const getMuiTheme = () =>
    createTheme({
      components: {
        MUIDataTableBodyCell: {
          styleOverrides: {
            root: {
              fontFamily: "Inter",
              textAlign: "center",
              fontSize: "16px",
              fontWeight: "400",
            },
          },
        },
      },
    });

  return (
    <div className="report-table-container">
      <ThemeProvider theme={getMuiTheme}>
        <div className="report-info-top-container">
          <p>{report.title}</p>
          <p
            onClick={() => {
              navigator.clipboard.writeText(window.location.href);
              alert("Report Link Copied to Clipboard");
            }}
          >
            Copy Report Link
          </p>
          <p>
            Link is Valid for{" "}
            {moment(report.createdAt).add(24, "hours").diff(moment(), "hours")}{" "}
            hours
          </p>
        </div>
        <MUIDataTable
          data={report.reportInfo}
          title={""}
          columns={columns}
          options={options}
        />
      </ThemeProvider>
    </div>
  );
};

export default ItemReportsTable;
